import { render, staticRenderFns } from "./tiscSection.vue?vue&type=template&id=0270509b&scoped=true&"
import script from "./tiscSection.vue?vue&type=script&lang=js&"
export * from "./tiscSection.vue?vue&type=script&lang=js&"
import style0 from "./tiscSection.vue?vue&type=style&index=0&id=0270509b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270509b",
  null
  
)

export default component.exports